export function useRouter({ router, route }) {
    function to({
        alias,
        newParams,
        options = {}
    }: {
        alias?: string;
        newParams: any;
        options?: any;
    }) {
        let params = route().params;
        let filterParams = params.filter ?? {};
        let newFilterParams = newParams.filter ?? {};

        //if a param doesn't exist on the new params, remove it 
        for (const key in filterParams) {
            if (!newFilterParams[key]) {
                delete filterParams[key];
            }
        }
        router.visit(
            route(alias ?? route().current(), {
                ...params,
                ...newParams,
                filter: {
                    ...filterParams,
                    ...newFilterParams
                }
            }),
            options
        );
    }

    return {
        to
    };
}
